
export const INCRECEMENT = 'INCREMENT'
export const TOGGLE_POPUP = 'TOGGLE_POPUP'
export const CLOSE_POPUP = 'CLOSE_POPUP'
export const SUBMIT_KEYWORD = 'SUBMIT_KEYWORD'
export const SET_POPUP = 'SET_POPUP'
export const SET_SCROLL = 'SET_SCROLL'
export const SET_LOADING = 'SET_LOADING'
export const SAVE_AUTH = 'SAVE_AUTH'
export const SAVE_NAME = 'SAVE_NAME'
export const SET_USER = 'SET_USER'
export const SAVE_USERINFO = 'SAVE_USERINFO'
export const SAVE_USERINFOALL = 'SAVE_USERINFOALL'
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE'
export const SAVE_PRIVI = 'SAVE_PRIVI'
export const SAVE_USERTYPE = 'SAVE_USERTYPE'
export const SYNC_AUTHINFO = 'SYNC_AUTHINFO'
export const SAVE_LIVEURL = 'SAVE_LIVEURL'
export const SAVE_JHOS = 'SAVE_JHOS'
export const SAVE_JRNAME = 'SAVE_JRNAME'
export const SAVE_JDEPTNAME = 'SAVE_JDEPTNAME'
export const SAVE_JUNI = 'SAVE_JUNI'
export const SAVE_JMAJOR = 'SAVE_JMAJOR'
export const SAVE_JDOCID = 'SAVE_JDOCID'
export const SAVE_JDOCTYPE = 'SAVE_JDOCTYPE'
export const SAVE_JPATH = 'SAVE_JPATH'
export const SAVE_APROGRESS = 'SAVE_APROGRESS'
export const SAVE_CASEID = 'SAVE_CASEID'
export const SAVE_ANSWERRECORDID = 'SAVE_ANSWERRECORDID'
export const SAVE_AZITEMS = 'SAVE_AZITEMS'
export const SAVE_DOC_FOCUS_COLUMN = 'SAVE_DOC_FOCUS_COLUMN'
export const SAVE_WHITE_MOBILE_LIST = 'SAVE_WHITE_MOBILE_LIST'
export const SAVE_ISRIGISTER = 'SAVE_ISRIGISTER'
export const SQSM_FILTER_JSON = 'SQSM_FILTER_JSON'
export const SYNC_PRESONALINFO = 'SYNC_PRESONALINFO'
export const UPDATE_PRESONALINFO = 'UPDATE_PRESONALINFO'
export const SAVE_ISCOMPLETE = 'SAVE_ISCOMPLETE'
export const SAVE_COMPLETEPATH = 'SAVE_COMPLETEPATH'
export const SAVE_onlyLackDisease = 'SAVE_onlyLackDisease'
export const UPDATE_EDCSOURCEDATA = 'UPDATE_EDCSOURCEDATA'
export const UPDATE_EDCSOURCEPATIENT = 'UPDATE_EDCSOURCEPATIENT'
export const UPDATE_EDCSUBPROJECTCODE = 'UPDATE_EDCSUBPROJECTCODE'
export const SAVE_EDCDOCTORINFO = 'SAVE_EDCDOCTORINFO'//EDC 医生基础信息（一次性给所有属性赋值）
export const UPDATE_EDCDOCTORINFO_ITEM = 'UPDATE_EDCDOCTORINFO_ITEM'//更新 EDC 医生基础信息 的具体属性的值（给具体属性赋值）
export const UPDATE_EDCDOCTORINFO_BANK_ITEM = 'UPDATE_EDCDOCTORINFO_BANK_ITEM'//更新 EDC 医生基础信息--银行信息 的具体属性的值
export const SAVE_IHAPPLYINFO = 'SAVE_IHAPPLYINFO'//互联网医院申请入驻 医生基础信息 （一次性给所有属性赋值）
export const UPDATE_IHAPPLYINFO_ITEM = 'UPDATE_IHAPPLYINFO_ITEM'//更新 互联网医院申请入驻 医生基础信息 的具体属性的值（给具体属性赋值）
export const CUSTOM_LIMITTIME_TASK = 'CUSTOM_LIMITTIME_TASK'
export const SAVE_CONFIGWX_INFO = 'CUSTOM_WXCONFIG_INFO'
